import styled from 'styled-components';
import { CSSProperties } from 'react';

const TooltipContainer = styled.div`
	top: 112px;
  display: flex;
  align-items: center;
  gap: 16px;
  background: var(--modalBgColor);
  padding: 12px 18px;
  border-radius: 8px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.12);
  border: 1px solid var(--borderLightColor);
  min-width: 320px;
	left:  50%;

	@media (max-width: 700px) {
		flex-direction: column;
		gap:12px;
	}
	@media (max-width: 590px) {
		 left: 1%;
		 transform: translateX(0) !important;
	}	
		@media (max-width: 560px) {
			top: 160px;
	} 
`;

const Status = styled.div`
  display: flex;
  align-items: center;
	color: var(--textTitleColor);
	font-size: 14px;
	font-weight: 500;
	flex: 1;
`;

const Actions = styled.div`
  display: flex;
  align-items: center;
	display: flex;
  gap: 10px;
`;

const ActionButton = styled.button`
	font-size: 14px;
  padding: 5px 14px; // withount border 6px 14px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
	font-family: 'Inter';
	font-weight: 500;
	border: 1px solid currentColor; // none

	&.confirm-btn{
		 background: var(--primary);
  	 color: var(--btnLabel);
	}
	&.discard-btn{
		 background: transparent;
  	 color: var(--textTitleColor);
		 border-color: rgba(100, 104, 106, 0.15);
		 &:hover{
		 	 background: var(--chipBgColor);
			 border-color: var(--cardBorderColor);
		 }
	}
	&:hover {
    opacity: 0.9;
  }	
`;
const AbsoluteContainer = styled.div`
	position: absolute;
	top: 0;
	left:0;
	right:0;
	bottom:0;
	display: flex;
	justify-content: center;
	align-items: flex-start;
	width: 100%;
	height: 100%;
	flex:1;
	z-index: 9999;
	background: rgb(233 233 233 / 10%);
	`;
const DivRelative = styled.div`
position: relative;
	flex:1;
`	;
const CloseButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  line-height: 1;
	padding: 6px 3px 3px;
  &:hover {
    opacity: 0.75;
  }
`;
const popupContentStyle: CSSProperties = {
	position: 'fixed',
	top: '112px',
	left: 0,
	right: 0,
	margin: '0 auto',
	width: 'fit-content', 
	padding: 0,
	border: 'none',
	background: 'transparent',
	zIndex: 9999,
	maxWidth: '472px',
};

export {
	CloseButton,
	ActionButton,
	Actions,
	TooltipContainer,
	Status,
	popupContentStyle,
	DivRelative,
	AbsoluteContainer
};